/**
 * MeasurementsConverter class
 *
 *     const converter = new MeasurementsConverter();
 *
 * An object that encapsulates the identifier and conversion factor for a length unit.
 */
export default class MeasurementsConverter {
    /**
     * Converts the value to the provided length unit.
     *
     * @param {number} value
     * @param {LengthUnit} lengthUnit
     * @param {number} decimals
     *
     * @return {number}
     */
    convertTo(value, lengthUnit, decimals = 0) {
        const decimalsFactor = 10 ** decimals;
        let floatValue = parseFloat(value) || 0.0;

        floatValue *= lengthUnit.getConversionFactor();

        if (typeof decimals === 'number') {
            floatValue = Math.round((floatValue * decimalsFactor)) / decimalsFactor;
        }

        return floatValue;
    }

    /**
     * Converts the value to the origin length unit.
     *
     * @param {number} value
     * @param {LengthUnit} lengthUnit
     * @param {number} decimals
     *
     * @return {number}
     */
    convertFrom(value, lengthUnit, decimals) {
        const decimalsFactor = 10 ** decimals;
        let floatValue = parseFloat(value) || 0.0;

        floatValue /= lengthUnit.getConversionFactor();

        if (typeof decimals === 'number') {
            floatValue = Math.round((floatValue * decimalsFactor)) / decimalsFactor;
        }

        return floatValue;
    }
}
